"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _url = require("url");
var _useDebounce = require("use-debounce");
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _constants = require("../../../constants");
var _filters = require("../../config/filters");
var _utils = require("../utils");
var _hooks = require("../hooks");
var _hooks2 = require("../../hooks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "dropdown": "dropdown_JxIorn",
  "dropdown-header": "dropdown-header_3dOJKT",
  "dropdownHeader": "dropdown-header_3dOJKT",
  "dropdown-content": "dropdown-content_3mQK1J",
  "dropdownContent": "dropdown-content_3mQK1J",
  "dropdown-list": "dropdown-list_32KoMK",
  "dropdownList": "dropdown-list_32KoMK",
  "dropdown-list-item": "dropdown-list-item_1Aa6Bb",
  "dropdownListItem": "dropdown-list-item_1Aa6Bb",
  "clickable-list-item": "clickable-list-item_2kW_Sf",
  "clickableListItem": "clickable-list-item_2kW_Sf",
  "list-item-label": "list-item-label_E7V1bf",
  "listItemLabel": "list-item-label_E7V1bf",
  "list-item-description": "list-item-description_niKmT0",
  "listItemDescription": "list-item-description_niKmT0",
  "dropdown-footer": "dropdown-footer_1Fqse5",
  "dropdownFooter": "dropdown-footer_1Fqse5",
  "dropdown-footer-actions": "dropdown-footer-actions_1G-MJa",
  "dropdownFooterActions": "dropdown-footer-actions_1G-MJa"
}; 
require('./CustomFieldsOptions.css');
const DROPDOWN_OPTIONS_ID = 'custom-fields-dropdown-options';
const CustomFieldsOptions = ({
  options = [],
  onSearch,
  onChange,
  value,
  id
}) => {
  var _facetsContext$facets;
  const [selectedOptionId, setSelectedOptionId] = (0, _react.useState)(value === null || value === void 0 ? void 0 : value.tagKey);
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = (0, _react.useState)('');
  const organizationId = (0, _exchangeReactHooks.useActiveOrganizationId)();
  const facetsContext = (0, _react.useContext)(_hooks2.FacetsContext);
  const hasFieldsFilter = facetsContext === null || facetsContext === void 0 || (_facetsContext$facets = facetsContext.facets) === null || _facetsContext$facets === void 0 ? void 0 : _facetsContext$facets.hasFieldsFilter;
  const query = facetsContext === null || facetsContext === void 0 ? void 0 : facetsContext.query;
  const fetch = (0, _exchangeReactHooks.useFetch)();
  const tryFn = (0, _exchangeReactHooks.useTryFn)();
  const updateDebounceSearchTerm = (0, _useDebounce.useDebouncedCallback)(term => setDebouncedSearchTerm(term), _constants.SEARCH_FUNCTION_DELAY);
  const optionsRef = (0, _react.useRef)();
  const onKeyDown = (0, _hooks.useArrowHandling)(optionsRef, []);
  (0, _react.useEffect)(() => {
    var _optionsRef$current;
    (_optionsRef$current = optionsRef.current) === null || _optionsRef$current === void 0 || _optionsRef$current.focus();
  }, []);
  const filteredOptions = (0, _react.useMemo)(() => options.filter(({
    displayName,
    tagKey
  }) => (0, _utils.includesTerm)(displayName, searchTerm) || (0, _utils.includesTerm)(tagKey, searchTerm)), [options, searchTerm]);
  const onSearchTermChange = (0, _react.useCallback)(({
    value: term
  }) => {
    setSearchTerm(term);
    updateDebounceSearchTerm(term);
  }, []);
  const selectOption = (0, _react.useCallback)(option => {
    setSelectedOptionId(option.tagKey);
    onChange(option);
  }, [onChange]);
  const onClickOption = option => selectOption(option);
  const onKeyDownOption = (event, option) => {
    if (['Enter', ' '].includes(event.key)) {
      selectOption(option);
    }
  };
  const currentOption = options.find(({
    tagKey
  }) => tagKey === selectedOptionId);
  _react.default.useEffect(() => {
    if (hasFieldsFilter && debouncedSearchTerm && organizationId) {
      tryFn(async () => {
        const url = (0, _url.format)({
          pathname: `/api/v2/organizations/${organizationId}/ang/facets/customer-metadata.CustomerMetadataNode.fields`,
          query: _objectSpread(_objectSpread({}, query), {}, {
            _aggr_field_t: debouncedSearchTerm
          })
        });
        const response = await fetch(url);
        const result = await response.json();
        onSearch(result.fields);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFieldsFilter, debouncedSearchTerm, organizationId]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    role: "listbox",
    className: styles.dropdown,
    "data-test-id": "custom-fields-filter-dropdown"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownHeader
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "search",
    placeholder: "Search",
    size: "md",
    onChange: onSearchTermChange,
    value: searchTerm,
    className: styles.searchInput,
    role: "combobox",
    "aria-autocomplete": "list",
    "aria-controls": DROPDOWN_OPTIONS_ID,
    "aria-label": "Search"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownContent
  }, /*#__PURE__*/_react.default.createElement("ul", {
    id: DROPDOWN_OPTIONS_ID,
    className: styles.dropdownList,
    role: "listbox",
    ref: optionsRef,
    tabIndex: 0,
    onKeyDown: onKeyDown
  }, filteredOptions.map(option => /*#__PURE__*/_react.default.createElement("li", {
    role: "option",
    "aria-selected": !!selectedOptionId && selectedOptionId === currentOption.tagKey,
    className: (0, _classnames.default)(styles.dropdownListItem, styles.clickableListItem),
    key: option.displayName,
    tabIndex: -1,
    onClick: () => onClickOption(option),
    onKeyDown: e => onKeyDownOption(e, option)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.listItemLabel
  }, /*#__PURE__*/_react.default.createElement("span", null, option.displayName, " "), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.listItemDescription
  }, "(", _filters.CUSTOM_FIELDS_TYPES_LABEL[option.dataType], ")")))))));
};
var _default = exports.default = CustomFieldsOptions;
//# sourceMappingURL=CustomFieldsOptions.js.map